import { ThemeProvider } from './app/providers/theme';
import { LanguageProvider } from './app/providers/language';
import { AuthProvider } from './app/providers/auth';
import { NotificationProvider } from './app/providers/notification';
import { QueryProvider } from './app/providers/query';
import { UploadProvider } from './app/providers/upload';
import UploadProgress from './app/layout/components/UploadProgress';
import { SelectionExportProgress } from './features/files/components/SelectionExportProgress';
import Layout from './app/layout/Layout';
import { DocumentMeta } from './shared/components/DocumentMeta';
import Views from './views';

function App() {
  return (
    <AuthProvider>
      <QueryProvider>
        <ThemeProvider>
          <LanguageProvider>
            <DocumentMeta />
            <NotificationProvider>
              <UploadProvider>
                <Layout>
                  <Views />
                </Layout>
                <UploadProgress />
                <SelectionExportProgress />
              </UploadProvider>
            </NotificationProvider>
          </LanguageProvider>
        </ThemeProvider>
      </QueryProvider>
    </AuthProvider>
  );
}

export default App;
